import { ColorClassnames } from '@stashinvest/tailwind/src/theme';
import React, { FC } from 'react';
import cls from 'classnames';
import { AssistiveTextProps, AssistiveTextVariant } from './AssistiveText.types';
import { getClassNames, getRootClassListFromProps } from '../../../../utilities/classNames';
import { WarningIcon } from '@stashinvest/react-assets';
import Text from '../../../content/text/Text';
export const classNames = getClassNames('sds-assistive-text', ['error-icon']);

const mapVariantToColor: Record<AssistiveTextVariant, ColorClassnames> = {
	error: 'text-error',
	hint: 'text-secondary',
};

const mapAlignmentToClass = {
	left: 'text-left',
	center: 'text-center',
};

const AssistiveText: FC<AssistiveTextProps> = (props) => {
	const { className, text, variant = 'hint', align = 'left',id } = props;
	return (
		<div
			id={id}
			className={cls(
				className,
				mapAlignmentToClass[align],
				getRootClassListFromProps(classNames, props)
			)}
		>
			{variant === 'error' && (
				<WarningIcon size="2XS" color="text-error" className={classNames.errorIcon} />
			)}
			<Text
				tag="span"
				color={mapVariantToColor[variant]}
				textAlign={align}
				textStyle="captionMediumStandard"
			>
				{text}
			</Text>
		</div>
	);
};

AssistiveText.displayName = 'AssistiveText';

export default AssistiveText;
